<template>
    <nav class="global-menu is-clickable">

        <!-- GLOBAL EVENTS -->
        <!-- <global-events
            @keydown.prevent.up="keyPress('up')"
            @keydown.prevent.down="keyPress('down')">
        </global-events> -->

        <!-- <button @click.stop="enterSystem">
            <span class="text">Hello?</span>
        </button> -->

        <button :class="isActive(0)" @click.stop="select(0)">
            <span class="text">New Game</span>
        </button>

        <button :class="isActive(1)" class="inactive" @click.stop="enterSystem">
            <span class="text">Continue</span>
        </button>

        <!-- <button :class="isActive(2)" @click.stop="select(2)">
            <span class="text">Settings</span>
        </button> -->

        <button :class="isActive(2)" @click.stop="logout">
            <span class="text">Exit</span>
        </button>

    </nav>
</template>

<script>
    import { mapActions } from 'vuex';
    import { mapGetters } from 'vuex';
    // import GlobalEvents from 'vue-global-events';

    export default {
        components: {
            // GlobalEvents,
        },
        data(){
            return {
                currentIndex: 0,
                totalCurrentItems: 4
            }
        },
        computed: {
            ...mapGetters('gameOS', [
                'showSystem',
                // 'getTheme'
            ]),
        },
        created() {
            // this.$on('down-arrow-pressed', function(){
            //     console.log('hello');
            // })
        },
        methods: {

            // don't need anymore - keep for reference though
            // keyPress(label){
            //     if (label == 'up' && this.currentIndex > 0) this.currentIndex--;
            //     if (label == 'down' && this.currentIndex < this.totalCurrentItems-1) this.currentIndex++;
            // },

            select(index){
                this.currentIndex = index;
            },
            enterSystem() {
                if (!this.showSystem) {
                    this.$store.dispatch('gameOS/showSystem', true);
                }
            },
            logout(e) {
                e.stopPropagation();

                // https://forum.vuejs.org/t/best-practice-to-change-the-route-vuerouter-after-a-mutation-vuex/5631/9
                this.$store.dispatch('player/logout').then(() => {
                    if (!this.$store.getters.error) {
                        this.$router.replace('/login/');
                    }
                });
            },
            isActive(index){
                // return { active: index === this.currentIndex }
            }
        }
    }
</script>

<style lang="scss" scoped>

    //-----------------------------------------------------------------
    // GLOBAL MENU
    //-----------------------------------------------------------------

    .global-menu {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        position: absolute;
        bottom: 50%;
        right: em-calc(30);
    }

    //-----------------------------------------------------------------
    // BUTTON
    //-----------------------------------------------------------------
$primary: lighten(#747068, 15%);
// $primary: lighten(saturate(#436264, 5%), 15%);
// $primary: #bfc8c6; //#c3faff;

    .global-menu button {
        border: 0;
        background: none;
        font-family: 'Avenir Next';
        font-weight: 600;
        font-size: em-calc(30);
        line-height: 1.3;
        text-transform: uppercase;
        // color: transparent; //$primary;
        // text-shadow: 0 0 1px $primary;

        // better?
        color: $primary;
        text-shadow: 0 0 2px $primary;
        filter: blur(0.38px);


        transition: text-shadow 400ms ease;
        z-index: 1;
        -webkit-font-smoothing: antialiased;

        .text {
            display: inline-block;
            transform-origin: right;
            transition: transform 1000ms ease;
        }
    }

    button.inactive {
        opacity: 0.2;
        pointer-events: none;
    }

    //-----------------------------------------------------------------
    // BUTTON STRIP
    //-----------------------------------------------------------------

    .global-menu button:after {
        // content: "";
        position: absolute;
        top: 0;
        right: 5px;
        width: 100%;
        height: calc(100% - 4px);
        background: $primary;
        opacity: 0;
        transform: scaleX(0.7);
        transform-origin: right;
        // filter: blur(0.8px);
        box-shadow: 0 0 1px 0px $primary;
        z-index: -1;
    }

    //-----------------------------------------------------------------
    // HOVERS / ACTIVE
    //-----------------------------------------------------------------

    button:hover,
    button.active {
        // color: #17171c;
        // text-shadow: 0 0 1px #17171c;

        text-shadow:
          0 0 2px $primary,
          0 0 5px $primary,
          0 0 10px rgba($primary, 0.1),
          0 0 20px rgba($primary, 0.1),
          0 0 40px rgba($primary, 0.1),
          0 0 10px rgba($primary, 0.1);

        // button strip
        &:after {
            transform: scaleY(1);
            transition: all 0.5s ease;
            opacity: 1;
        }

        .text {
            transform: translateX(-5px);
        }
    }
</style>